import { FC } from 'react';
import { Badge, Gray10, Gray100 } from '@traceair/tds';

type DeliverableStatusBadgeProps = {
  label: string;
  className?: string;
};

const customStyles = {
  backdropFilter: 'blur(12.5px)',
  background: Gray10,
  color: Gray100,
};

export const DeliverableStatusBadge: FC<DeliverableStatusBadgeProps> = ({ label, className }) => (
  <Badge className={className} label={label} size="s" type="neutral-gray" customStyles={customStyles} />
);
